import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import { PrivateRoute } from "@/components/auth/PrivateRoute";
import Perfil from "@/pages/Perfil";

export const Route = createFileRoute("/perfil")({
  head: () => seoHead({
    title: "Configurações | Shopping do Bem",
    description: "Gerencie suas configurações de conta no Shopping do Bem.",
    path: "/perfil", noindex: true,
  }),
  component: () => (
    <PrivateRoute>
      <Perfil />
    </PrivateRoute>
  ),
});
